/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dropdown } from "react-bootstrap";
import SntGroupBy from "@icons/SntGroupBy";
import SntUnGroup from "@icons/SntUnGroup";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { FeatureKey } from "@/types/generated/FeatureKey";
import { translate } from "@/hooks/useLanguage";
import { hasFeature } from "@/hooks/useFeatures";
import {
  dateBucketTypes,
  supportedGroupTypeConstant,
} from "@/components/SntTableViewCard/SntTableConfigurationConstant";

interface GroupActionsProps {
  column: any;
  headerGroup: any;
  dataFilter: any;
  isDisabbledGroup: boolean;
}

export const GroupActions = ({
  column,
  headerGroup,
  dataFilter,
  isDisabbledGroup,
}: GroupActionsProps) => {
  const showGroupActions =
    hasFeature(FeatureKey.search_aggregate) &&
    !isDisabbledGroup &&
    !column.disabledGroupColumn;

  if (!showGroupActions) return null;

  const handleToggleGroup = () => {
    dataFilter?.toggleGroupColumnKey?.(column.key);
  };

  if (column.supportedGroupType === supportedGroupTypeConstant.DATE_BUCKET) {
    return (
      <>
        {dateBucketTypes.map((bucketType) => {
          let desc = false;
          if (column.isSorted) {
            desc = column.isSortedDesc;
          }
          return (
            <Dropdown.Item
              key={bucketType}
              bsPrefix="dropdown-item"
              onClick={() => {
                if (column.bucketType === bucketType) {
                  dataFilter?.toggleGroupColumnKey?.(column.key);
                } else {
                  dataFilter?.setColumnsSetting?.(
                    headerGroup.headers.map((c: any) => c.key),
                    {
                      key: column.key,
                      desc: desc,
                    },
                    column.key,
                    bucketType,
                    column.supportedAggregateMetrics.map(
                      (metric: any) => column.key + "." + metric.toLowerCase()
                    )
                  );
                }
              }}
            >
              <div className="d-flex">
                <div style={{ width: 20 }} className="d-flex align-items-center">
                  {column.isGrouped && column.bucketType === bucketType ? (
                    <SntUnGroup />
                  ) : (
                    <SntGroupBy />
                  )}
                </div>
                <div>
                  {(() => {
                    const ungroupKey = `ungroup_column_${bucketType.toLowerCase()}`;
                    const groupKey = `group_by_${bucketType.toLowerCase()}`;
                    return column.isGrouped && column.bucketType === bucketType
                      ? translate(ungroupKey as LanguageKey)
                      : translate(groupKey as LanguageKey);
                  })()}
                </div>
              </div>
            </Dropdown.Item>
          );
        })}
        <Dropdown.Divider className="table-group-menu-divider" />
      </>
    );
  }

  return (
    <>
      <Dropdown.Item bsPrefix="dropdown-item" onClick={handleToggleGroup}>
        <div className="d-flex">
          <div style={{ width: 20 }} className="d-flex align-items-center">
            {column.isGrouped ? <SntUnGroup /> : <SntGroupBy />}
          </div>
          <div>
            {column.isGrouped
              ? translate(LanguageKey.ungroup_column_key)
              : translate(LanguageKey.group_column_key)}
          </div>
        </div>
      </Dropdown.Item>
      <Dropdown.Divider className="table-group-menu-divider" />
    </>
  );
};
